import { Col, Dropdown, Menu, Row } from "antd";
import React, { FC } from "react";
import "./exerciseCardsAnalytics.scss";
import ScoreIcon from "../../../../assets/icons/reward.svg";
import AccuracyIcon from "../../../../assets/icons/dart.svg";
import SpeedIcon from "../../../../assets/icons/sketch.svg";
import { DownOutlined } from "@ant-design/icons";
import DurationIcon from "../../../../assets/icons/sand-clock.svg";
import Chart from "react-google-charts";
import { ExerciseModal } from "../../../../models/ExerciseModal/Exercise.model";
const QuestionStats = ({ nos, text, color }: any) => {
  return (
    <div className={"question-stats__wrapper"} style={{ borderColor: color }}>
      <p className="nos">{nos}</p>
      <p className="text">{text}</p>
    </div>
  );
};
interface ExercisesCardsAnalyticsProps {
  exercises: any[];
}
const ExercisesCardsAnalytics: FC<ExercisesCardsAnalyticsProps> = ({
  exercises,
}) => {
  const colors = {
    blue: {
      dark: "#145CE7",
      light: "#D0DEFA",
    },
    black: {
      dark: "#0C1013",
      light: "#ECEDEF",
    },
    orange: {
      dark: "#FF9810",
      light: "#FFEACF",
    },
    red: {
      dark: "#DC1313",
      light: "#F8CFCF",
    },
    green: {
      dark: "#108E10",
      light: "#CFE8CF",
    },
  };
  const menu = (
    <Menu>
      <Menu.Item>
        <a>1st menu item</a>
      </Menu.Item>
      <Menu.Item>
        <a>2nd menu item</a>
      </Menu.Item>
    </Menu>
  );
  return (
    <Row className="exercises__wrapper">
      {exercises?.map((value: ExerciseModal, index) => {
        return (
          <Col span={24} className="exercises__card">
            <Row>
              <Col span={8} className="exercise-performance__card">
                <div className="exercise-card__header">
                  <p className="exercise__title">{value.title}</p>
                  <Dropdown overlay={menu}>
                    <p onClick={(e) => e.preventDefault()}>
                      Attempt 1 <DownOutlined />
                    </p>
                  </Dropdown>
                  <div className="exercise__rank">Rank 04</div>
                </div>
                <div className="exercise-card__performance">
                  <div className="flex align-center exercise-card-performance__content">
                    <img src={ScoreIcon} />
                    <p className="exercise-card-performance__measure">Score</p>
                    <p className="exercise-card-performance-measure__value">
                      67
                    </p>
                  </div>
                  <div className="flex align-center exercise-card-performance__content">
                    <img src={SpeedIcon} />
                    <p className="exercise-card-performance__measure">Speed</p>
                    <p className="exercise-card-performance-measure__value">
                      01 <span>sec/ques</span>
                    </p>
                  </div>
                  <div className="flex align-center exercise-card-performance__content">
                    <img src={AccuracyIcon} />
                    <p className="exercise-card-performance__measure">
                      Accuracy
                    </p>
                    <p className="exercise-card-performance-measure__value">
                      80%
                    </p>
                  </div>
                  <div className="flex align-center exercise-card-performance__content">
                    <img src={DurationIcon} />
                    <p className="exercise-card-performance__measure">
                      Duration
                    </p>
                    <p className="exercise-card-performance-measure__value">
                      1<span>d</span> 11<span>h</span> 23<span>m</span>
                    </p>
                  </div>
                </div>
              </Col>
              <Col span={8} className="exercise-stats__card">
                <Row justify="space-around">
                  <Col span={4}>
                    <QuestionStats
                      nos={5}
                      text="Correct"
                      color={colors.green?.dark}
                    />
                  </Col>
                  <Col span={4}>
                    <QuestionStats
                      nos={2}
                      text="Incorrect"
                      color={colors.red?.dark}
                    />
                  </Col>
                  <Col span={4}>
                    <QuestionStats
                      nos={2}
                      text="Evaluating"
                      color={colors.orange.dark}
                    />
                  </Col>
                  <Col span={4}>
                    <QuestionStats
                      nos={1}
                      text="Unanswered"
                      color={colors.black.dark}
                    />
                  </Col>
                </Row>
                <Chart
                  width={"100%"}
                  height={"225px"}
                  chartType="PieChart"
                  loader={<div>Loading Chart</div>}
                  data={[
                    ["Attempt", "Performance per Attempt"],
                    ["Correct", 5],
                    ["Incorrect", 2],
                    ["Evaluating", 2],
                    ["Unanswered", 1],
                  ]}
                  options={{
                    title: "",
                    is3D: true,
                    slices: {
                      0: { color: colors.green?.dark },
                      1: { color: colors.red?.dark },
                      2: { color: colors.orange?.dark },
                      3: { color: colors.black?.dark },
                    },
                  }}
                  rootProps={{ "data-testid": "2" }}
                />
              </Col>
              <Col span={8} className="exercise-score__card">
                <Dropdown overlay={menu}>
                  <p onClick={(e) => e.preventDefault()}>
                   Score trend graph <DownOutlined />
                  </p>
                </Dropdown>
                <Chart
                  width={"100%"}
                  height={"220px"}
                  chartType="AreaChart"
                  loader={<div>Loading Chart</div>}
                  data={[
                    ["Attempt", "Score"],
                    ["1", 35],
                    ["2", 45],
                    ["3", 38],
                    ["4", 30],
                    ["5", 25],
                  ]}
                  options={{
                    title: "",
                    legend:{position: "none"},
                    hAxis: {
                      title: "Attempt",
                      titleTextStyle: { color: "#333" },
                    },
                    vAxis: { minValue: 0 },
                    chartArea: { width: "75%", height: "70%" },
                    colors: [colors.green.dark],
                  }}
                  rootProps={{ "data-testid": "1" }}
                />
              </Col>
            </Row>
          </Col>
        );
      })}
    </Row>
  );
};
export default ExercisesCardsAnalytics;
